import React from 'react';
import { Link } from "react-router-dom";

import { ArrowLeftIcon } from "@heroicons/react/solid";
import classNames from "classnames";

const classes = {
    link: classNames('p-6 inline-block hover:bg-gray-100'),
    arrow: classNames('w-4')
};

export default function BackLink({to}) {
    return <Link to={to} className={classes.link}>
        <ArrowLeftIcon className={classes.arrow} />
    </Link>;
}
